import { createGetRequest } from '../tools/request.js';
import { API_URLS } from '../constants/urls.js';
const getCsrfToken = async () => {
    try {
        await createGetRequest(API_URLS.BFF.TOKEN);
        return true;
    }
    catch (error) {
        return false;
    }
};
const TokenService = {
    getCsrfToken,
};
export default TokenService;
//# sourceMappingURL=tokens.js.map